import { render, staticRenderFns } from "./InspectionDetail.vue?vue&type=template&id=574d1322&scoped=true&"
import script from "./InspectionDetail.vue?vue&type=script&lang=js&"
export * from "./InspectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./InspectionDetail.vue?vue&type=style&index=0&id=574d1322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574d1322",
  null
  
)

export default component.exports